import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Radio from './src/radio.vue'
import RadioButton from './src/radio-button.vue'
import RadioCard from './src/radio-card.vue'
import RadioGroup from './src/radio-group.vue'

export const JdRadio = withInstall(Radio, {
  RadioButton,
  RadioCard,
  RadioGroup,
})
export default JdRadio
export const JdRadioGroup = withNoopInstall(RadioGroup)
export const JdRadioButton = withNoopInstall(RadioButton)
export const JdRadioCard = withNoopInstall(RadioCard)

export * from './src/radio'
export * from './src/radio-group'
export * from './src/radio-button'
export * from './src/radio-card'
export * from './src/constants'
